import { Plus } from 'lucide-react';
import JsonLd from '@/components/JsonLd';
import Reveal from '@/components/Reveal';
import Section, { SectionHeading } from '@/components/Section';
import { FAQ_ITEMS } from '@/data/content';

const SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQ_ITEMS.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
};

// Odgovori su u HTML-u (details/summary), pa su vidljivi i pretraživačima bez JavaScripta.
export default function Faq() {
  return (
    <Section id="faq" tone="paper">
      <JsonLd data={SCHEMA} />
      <div className="grid gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
        <SectionHeading eyebrow="Pitanja i odgovori" title="Česta pitanja." />
        <Reveal>
          <div className="border-t border-ink/15" data-testid="faq-list">
            {FAQ_ITEMS.map(({ q, a }) => (
              <details key={q} className="group border-b border-ink/15">
                <summary className="flex cursor-pointer list-none items-center justify-between gap-6 py-5 text-lg font-semibold [&::-webkit-details-marker]:hidden">
                  {q}
                  <Plus
                    className="h-5 w-5 shrink-0 text-brand transition-transform duration-200 group-open:rotate-45"
                    aria-hidden="true"
                  />
                </summary>
                <p className="pb-6 pr-10 leading-relaxed text-ink/75">{a}</p>
              </details>
            ))}
          </div>
        </Reveal>
      </div>
    </Section>
  );
}
